import { render, staticRenderFns } from "./index.vue?vue&type=template&id=61c2b99a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=61c2b99a&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=61c2b99a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c2b99a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61c2b99a')) {
      api.createRecord('61c2b99a', component.options)
    } else {
      api.reload('61c2b99a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=61c2b99a&scoped=true", function () {
      api.rerender('61c2b99a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/primer/localCardList/fields/index.vue"
export default component.exports